<div class="xp-header__bar">
	<div class="xp-header__left">
		<div class="xp-header__brand">
			<img class="xp-header__logo" [src]="logoSrc()" width="92" height="32" [alt]="logoAlt()">
			<ng-container *ngIf="portalName()">
				<span class="xp-header__divider" aria-hidden="true"></span>
				<span class="xp-header__portal-name">{{ portalName() }}</span>
				<span *ngIf="badge()" class="xp-header__badge">{{ badge() }}</span>
			</ng-container>
		</div>
	</div>

	<div class="xp-header__right">
		<div class="xp-header__actions">
			<button *ngIf="showHelp() && !helpMenuItems().length"
			        type="button"
			        class="xp-header__action xp-header__help"
			        (click)="helpClick.emit()">
				<img [src]="helpIconSrc()" width="18" height="18" alt="">
				<div class="xp-header__help-text">Help</div>
			</button>
			<button *ngIf="showHelp() && helpMenuItems().length"
			        type="button"
			        class="xp-header__action xp-header__help"
			        data-testid="portal-header-help"
			        [matMenuTriggerFor]="helpMenu"
			        aria-haspopup="menu"
			        aria-label="Help">
				<img [src]="helpIconSrc()" width="18" height="18" alt="">
				<div class="xp-header__help-text">Help</div>
			</button>

			<mat-menu #helpMenu="matMenu" xPosition="before" yPosition="below" panelClass="xp-header__help-menu">
				<button *ngFor="let item of helpMenuItems()"
				        mat-menu-item
				        type="button"
				        class="xp-header__help-item"
				        (click)="helpMenuSelect.emit(item.id)">
					<mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
					<span>{{ item.label }}</span>
				</button>
			</mat-menu>

			<button type="button"
			        class="xp-header__trigger"
			        data-testid="portal-header-profile-trigger"
			        [matMenuTriggerFor]="profileMenu"
			        aria-label="Open profile menu">
				<xp-avatar class="xp-header__avatar" [imageUrl]="userAvatar()" [initials]="initials()" alt="User Avatar"></xp-avatar>
				<mat-icon class="xp-header__chevron">expand_more</mat-icon>
			</button>

			<mat-menu #profileMenu="matMenu" xPosition="before" yPosition="below">
				<div class="xp-header__menu-section xp-header__menu-head" (click)="$event.stopPropagation()">
					<xp-avatar class="xp-header__avatar xp-header__menu-avatar" [imageUrl]="userAvatar()" [initials]="initials()"></xp-avatar>
					<div class="xp-header__menu-user">
						<div class="xp-header__menu-name">{{ userName() || 'User' }}</div>
						<div *ngIf="userRole()" class="xp-header__menu-role">{{ userRole() }}</div>
					</div>
				</div>

				<mat-divider></mat-divider>

				<ng-container *ngIf="code()">
					<div class="xp-header__menu-section" (click)="$event.stopPropagation()">
						<div class="xp-header__code">
							<div>
								<div class="xp-header__code-value">{{ code() }}</div>
								<div class="xp-header__code-label">{{ codeLabel() }}</div>
							</div>
							<button type="button"
							        class="xp-header__copy"
							        [attr.aria-label]="'Copy ' + codeLabel()"
							        (click)="onCopy($event)">
								<mat-icon>content_copy</mat-icon>
							</button>
						</div>
					</div>

					<mat-divider></mat-divider>
				</ng-container>

				<button mat-menu-item class="xp-header__menu-item" data-testid="portal-header-profile" (click)="profileClick.emit()">
					<mat-icon>person_outline</mat-icon>
					<span>My Profile</span>
				</button>
				<button *ngIf="showHelp()"
				        mat-menu-item
				        class="xp-header__menu-item"
				        (click)="helpClick.emit()">
					<mat-icon>help_outline</mat-icon>
					<span>Help Center</span>
				</button>

				<mat-divider></mat-divider>

				<button mat-menu-item
				        class="xp-header__menu-item xp-header__menu-logout"
				        data-testid="portal-header-logout"
				        (click)="logout.emit()">
					<mat-icon>logout</mat-icon>
					<span>Logout</span>
				</button>
			</mat-menu>
		</div>
	</div>
</div>
